import React from "react";

import LetterDialog, { LetterDialogActions, letterModalBodyClass } from "../UX/LetterDialog";

function DeleteRecipientModal({ open = true, onClose, onConfirm }) {
  return (
    <LetterDialog
      open={open}
      onClose={onClose}
      centered
      animationVariant="scaleFade"
      title="Supprimer le destinataire"
      footer={
        <LetterDialogActions
          secondaryLabel="Supprimer"
          onSecondary={onConfirm}
          secondaryVariant="outline-red"
          primaryLabel="Conserver le destinataire"
          onPrimary={onClose}
          primaryVariant="green"
        />
      }
    >
      <p className={`${letterModalBodyClass} text-center`}>
        Es-tu sûr de vouloir supprimer ce destinataire ?
        <br />
        Son timbre te sera rendu immédiatement.
      </p>
    </LetterDialog>
  );
}

export default DeleteRecipientModal;
